import { SITE } from "@/lib/site";

const Block = ({ id, title, children }) => (
  <section id={id} className="border-t border-paper-line py-10">
    <h2 className="font-display text-3xl">{title}</h2>
    <div className="mt-4 space-y-3 text-slate-700 leading-relaxed">{children}</div>
  </section>
);

export default function Legal() {
  return (
    <main data-testid="legal-page" className="bg-paper px-5 pt-36 pb-24 sm:px-8">
      <div className="mx-auto max-w-3xl">
        <p className="eyebrow text-gold-deep mb-6">Informations légales</p>
        <h1 className="font-display text-5xl sm:text-6xl mb-10">Mentions légales</h1>
        <Block title="Éditeur du site">
          <p>{SITE.name} — {SITE.legalForm} : {SITE.owner}</p>
          <p>Siège : {SITE.address}</p>
          <p>SIREN {SITE.siren} · {SITE.siret} · Code NAF {SITE.naf}</p>
          <p>Directeur de la publication : {SITE.owner} · Tél. {SITE.phone} · {SITE.email}</p>
          <p>Assurance responsabilité civile décennale : [nom de l'assureur et n° de contrat].</p>
        </Block>
        <Block title="Hébergement">
          <p>Le site est hébergé par [nom et adresse de l'hébergeur].</p>
        </Block>
        <Block id="confidentialite" title="Politique de confidentialité">
          <p>Les informations recueillies via le formulaire de devis (nom, téléphone, e-mail, ville, description du projet) sont utilisées uniquement pour répondre à votre demande et ne sont jamais cédées à des tiers.</p>
          <p>Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données en écrivant à {SITE.email}.</p>
        </Block>
      </div>
    </main>
  );
}
